import { render, staticRenderFns } from "./raccoltaPunti.vue?vue&type=template&id=78de867e&"
import script from "./raccoltaPunti.vue?vue&type=script&lang=js&"
export * from "./raccoltaPunti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports